module.exports = __webpack_public_path__ + "media/images/bg-A-3c43d2a5ef90820d7c314ebcffbacdce.svg";